import { Button, Field, InlineNotice, Input } from "@bafe/ui";
import { useMutation } from "@tanstack/react-query";
import { type FormEvent, useState } from "react";
import { Link } from "react-router";

import { AuthShell } from "../../components/AuthShell";
import { ErrorPanel } from "../../components/ErrorPanel";
import { api } from "../../lib/api";

export function ForgotPassword() {
	const [email, setEmail] = useState("");

	const request = useMutation({ mutationFn: () => api.requestPasswordReset(email.trim()) });

	function submit(event: FormEvent<HTMLFormElement>) {
		event.preventDefault();
		request.mutate();
	}

	return (
		<AuthShell
			title="Reset your password"
			description="Enter the email address on your Key account and we will send a reset link."
			footer={
				<Link to="/signin" className="font-medium text-(--color-brand-700) underline underline-offset-2">
					Back to sign in
				</Link>
			}
		>
			{request.isSuccess ? (
				<InlineNotice tone="positive" title="Check your inbox">
					If an account exists for {email.trim()}, a reset link is on its way. The link expires shortly, so
					use it soon.
				</InlineNotice>
			) : (
				<form className="flex flex-col gap-4" onSubmit={submit} noValidate>
					<Field label="Email address" required>
						{({ id, describedBy, invalid }) => (
							<Input
								id={id}
								type="email"
								value={email}
								required
								autoComplete="username"
								autoCapitalize="none"
								spellCheck={false}
								aria-describedby={describedBy}
								aria-invalid={invalid}
								onChange={(event) => setEmail(event.target.value)}
							/>
						)}
					</Field>

					{request.isError && <ErrorPanel error={request.error} />}

					<Button
						type="submit"
						variant="primary"
						fullWidth
						pending={request.isPending}
						pendingLabel="Sending…"
					>
						Send reset link
					</Button>
				</form>
			)}
		</AuthShell>
	);
}
